// Service-worker registration glue. Registered as a module worker because the
// bundler emits ESM and modern Safari/Chrome/Firefox all support
// `{ type: "module" }`.
//
// We attempt registration unconditionally and let it fail naturally where
// `/sw.js` isn't served. The Bun dev server (`bun --hot server.ts`) has no
// route for `/sw.js`, so the fetch 404s, registration rejects, and HMR is
// untouched. Wrangler preview and Cloudflare Pages both serve `/sw.js` from
// `dist/`, so registration succeeds there.

export function registerSW(): void {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { type: "module" }).catch((err) => {
      console.warn("sw registration failed:", err);
    });
  });
}
